/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const htmlElem = document.querySelector('html');
const header = document.querySelector('#section-header');

const topBar = document.querySelector('#section-announcement');
const cartPopup = document.querySelector('#sidebar-cart');
const closeCartBtn = document.querySelector('button.Drawer__Close[data-drawer-id=sidebar-cart]');
let topBarH = 0;
if (found(topBar)) {
  topBarH = topBar.clientHeight;
}

const openCartBtn = document.querySelector('.Header__Icon.Icon-Wrapper.Icon-Wrapper--clickable[data-drawer-id=sidebar-cart]');
var windowH = window.innerHeight;
var windowW = window.innerWidth;

const openSearchMainMenu = document.querySelector('a[data-action=toggle-search]');
const openSearchSideMenu = document.querySelector('#sidebar-search-button');
const closeSideMenu = document.querySelector('button[data-drawer-id=sidebar-menu]');

const _addToCartBtn = document.querySelector('.ProductForm__AddToCart');
var openCartDrawer;

//Ici on keep si on décide que finalement le menu help s'ouvre on-click

// let helpButton = document.querySelector('#help-button');
// let helpPopup  = document.querySelector('.popup-help');
// function toggleHelpMenu() {
//     helpPopup.classList.add('show');
//     htmlElem.classList.add('no-scroll');
// }
// function closeHelpMenu(){
//     helpPopup.classList.remove('show');
//     htmlElem.classList.remove('no-scroll');
// }
// helpButton.addEventListener('mouseenter', () => {
//     toggleHelpMenu();
// });
// document.addEventListener('mouseout', () => {
//     closeHelpMenu();
// });


if (found(openCartBtn)) {
  window.addEventListener('resize', (e) => {
    updateDimension();
    checkCartBehaviour();
  })
  checkCartBehaviour();
}

function updateDimension() {
  windowH = window.innerHeight;
  windowW = window.innerWidth;
}

function checkCartBehaviour() {
  let currentBehaviour = openCartBtn.getAttribute('data-action');
  if (windowW < 1140 && currentBehaviour == 'open-drawer') {
    openCartBtn.setAttribute('data-action', 'none');
    openCartDrawer = false;
  } else if (windowW >= 1140 && currentBehaviour == 'none') {
    openCartBtn.setAttribute('data-action', 'open-drawer');
    openCartDrawer = true;
  }

  if (found(_addToCartBtn) && openCartDrawer === false) {
    _addToCartBtn.addEventListener('click', mobileCartCloser);
  } else if (found(_addToCartBtn) && openCartDrawer) {
    _addToCartBtn.removeEventListener('click', mobileCartCloser);
  }
}

function mobileCartCloser() {
  setTimeout(() => {
    /**
     * Ici on simule un click en dehors d'la box du drawer, comme ça le JS en background du thème gère
     * toutes les variables du 'state' de l'application, en gros ça referme le menu après 3 secondes
     */
    header.click();
  }, 3000);
}

function found(elem) {
  if (typeof elem === undefined || elem === null) {
    return false;
  } else {
    return true;
  }
}

// Handle de si on pèse sur le search dans le side menu mobile
if (found(openSearchSideMenu)) {
  openSearchSideMenu.addEventListener('click', () => {
    closeSideMenu.click();
    openSearchMainMenu.click();
  });
}

// Check si on pèse en dehors du panier popup
window.addEventListener('click', (e) => {
  let result = e.target.closest('#sidebar-cart');
  if (found(cartPopup)) {
    if (result === null && e.target.getAttribute('data-action') !== 'open-drawer' && cartPopup.getAttribute('aria-hidden') === 'false') {
      closeCartBtn.click();
    }
  }
});

function renderDone() {
  let renders = document.querySelectorAll('.rendering');
  renders.forEach(element => {
    element.classList.remove('rendering');
  });
}

function setHardWidth() {
  let elems = document.querySelectorAll('.set-hard-width');
  elems.forEach(element => {
    element.classList.add('rendering');
    element.style.width = element.clientWidth + "px";
    element.classList.remove('set-hard-width');
  });
  setTimeout(renderDone, 700)
}

setHardWidth();

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  if (formatString.match(placeholderRegex) !== null) {
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

};

window.addEventListener('load', () => {
  const CURLANG = document.querySelector('html').getAttribute('lang');
  if (CURLANG === 'en') {
    const inputPromoCode = document.querySelector('.limoniapps-discountninja-cartdiscountfield-input');
    if (inputPromoCode) {
      inputPromoCode.setAttribute('placeholder', 'Enter a discount code');
    }
    const applyPromoCode = document.querySelector('.limoniapps-discountninja-cartdiscountfield-apply');
    if (applyPromoCode) {
      applyPromoCode.innerHTML = 'Apply';

      const codeSearching        = document.querySelector('.limoniapps-discountninja-cartdiscountfield-searching span');
      const codeApplied          = document.querySelector('.limoniapps-discountninja-cartdiscountfield-applied p');
      const codeNotApplied       = document.querySelector('.limoniapps-discountninja-cartdiscountfield-notapplied span');
      const codeNotAppliedReason = document.querySelector('.limoniapps-discountninja-cartdiscountfield-notapplied-reason');
      const codeNotFound         = document.querySelector('.limoniapps-discountninja-cartdiscountfield-notfound span');
      const codeNotCombinable    = document.querySelector('.limoniapps-discountninja-cartdiscountfield-notcombinable span');

      codeSearching.innerHTML           = 'Searching...';
      codeApplied.innerHTML             = '<p><span style="color: rgb(57, 123, 33);">✔️ </span>Discount code found, it will be applied at checkout.</p>';
      codeNotApplied.innerHTML          = 'The discount code cannot be applied to the shopping cart. Restrictions may apply or the cart may not contain the correct items to use this promotion.';
      codeNotAppliedReason.innerHTML    = 'The discount code cannot be applied to the shopping cart. Please make sure the cart meets the requirements to apply this promo code.';
      codeNotFound.innerHTML            = 'Please provide a valid discount code.';
      codeNotCombinable.innerHTML       = 'The discount code cannot be combined with the offers applied to the cart.';
    }
  }
});

document.addEventListener("limoniapps:discountninja:promotions:loaded", function (event) {
  calcCardDiscountPrice(event);
  document.addEventListener('variant:modified', () => {
    calcCardDiscountPrice(event);
  });
});

function calcCardDiscountPrice(discountData) {
  var allOffers = discountData.detail.data[0];

  var cardOffer = allOffers.find(function (offer) {
    return offer.Token === 'SKT9B'
  });

  if (cardOffer) {
    var offerPercentage = cardOffer.Tiers[0].Entitlement.Percentage
    var $pricePlaceholder = jQuery('.card-pricing__price');

    var currentPrice = $pricePlaceholder.text();

    var $realPrice = document.querySelector('[data-product-price-raw]');
    if ($realPrice) {
      currentPrice = $realPrice.getAttribute('data-product-price-raw');
    }

    var newPrice = parseInt(currentPrice) * ((100 - offerPercentage) / 100);
    $pricePlaceholder.text(Shopify.formatMoney(newPrice, $pricePlaceholder.attr('data-format')));
    var collections = $pricePlaceholder.attr('data-collections');

    if (collections !== undefined) {
      if (cardOffer.Entitlement.ExcludeCollectionHandles && collections.split(',').includes(cardOffer.Entitlement.ExcludeCollectionHandles)) {
        return;
      }
    }

    $pricePlaceholder.closest('.card-pricing').show();
  }
}

// ---------------------------------------------------------------------------
// Header cart count (AJAX-updating)
// ---------------------------------------------------------------------------
class CartCountBadge extends HTMLElement {
  connectedCallback() {
    this.refresh = this.refresh.bind(this);
    document.documentElement.addEventListener('cart:refresh', this.refresh);
    this.refresh();
  }
  disconnectedCallback() {
    document.documentElement.removeEventListener('cart:refresh', this.refresh);
  }
  async refresh() {
    try {
      const response = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) {
        throw new Error('Failed to fetch cart: ' + response.status + ' ' + response.statusText);
      }
      const cart = await response.json();
      this.textContent = String(cart.item_count ?? 0);
    } catch (error) {
      console.error('Error refreshing cart count badge:', error);
      this.textContent = '';
    }
  }
}
customElements.define('cart-count-badge', CartCountBadge);
